





























import { defineComponent } from 'vue-demi';

export default defineComponent({
  data() {
    return {
      widgets: [
        {
          key: 'wi', name: 'A', y: 32, x: 72, width: 84, height: 84,
        },
        {
          key: 2, name: 'B', y: 132, x: 72, width: 84, height: 84,
        },
        {
          key: 3, name: 'C', y: 232, x: 72, width: 84, height: 84,
        },
        {
          key: 4, name: 'D', y: 332, x: 72, width: 84, height: 84,
        },
        {
          key: 5, name: 'E', y: 432, x: 72, width: 84, height: 84,
        },
      ],
      fields: {
        key: 'key',
        name: 'name',
        width: 'width',
        height: 'height',
        top: 'y',
        left: 'x',
      },
    };
  },
  methods: {
    handleUpdate(item: any) {
      const index = this.widgets.findIndex((widget) => widget.key === item.key);
      if (index !== -1) {
        const widget = { ...this.widgets[index], transition: item.transition };
        this.widgets.splice(index, 1, widget);
      }
    },
  },
});
